"use client";

import LoginForm from "@/app/components/login/LoginForm";
import FeatureList from "@/app/components/FeatureList";
import Image from "next/image";
import logo from "@/app/img/Logo-setdig-colorida.svg";
import { Box, Grid, Typography, useTheme, useMediaQuery } from "@mui/material";
import { useSession } from "next-auth/react";
import LoadingScreen from "@/app/components/loading/LoadingScreen";

export default function Home() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { status } = useSession();

  // Mostrar loading durante a verificação da sessão
  if (status === "loading") {
    return (
      <Box
        component="main"
        sx={{
          minHeight: "100vh",
          display: "flex",
          bgcolor: "var(--color-background-painel)",
          alignItems: "center",
          justifyContent: "center",
          p: 3,
        }}
      >
        <LoadingScreen
          title="Verificando sessão..."
          subtitle="Aguarde enquanto verificamos seu status de autenticação."
        />
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{
        minHeight: "100vh",
        display: "flex",
        bgcolor: "var(--color-background-painel)",
      }}
    >
      <Grid container sx={{ flex: 1 }}>
        {/* Lado esquerdo - Features e informações */}
        <Grid
          item
          xs={12}
          md={7}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            p: { xs: 3, md: 3 },
            order: { xs: 2, md: 1 },
          }}
        >
          <Box sx={{ maxWidth: 600, width: "100%" }}>
            {/* Logo */}
            <Box sx={{ mb: 4, display: "flex", alignItems: "center" }}>
              <Image
                src={logo || "/placeholder.svg"}
                alt="Logo SETDIG"
                width={400}
                style={{ height: "auto" }}
              />
            </Box>

            {/* Título principal */}
            <Typography
              variant="h3"
              component="h1"
              sx={{
                fontWeight: 700,
                mb: 2,
                color: "text.primary",
                fontSize: { xs: "2rem", md: "2.5rem" },
              }}
            >
              Monitor de Acessibilidade Web
            </Typography>

            <Typography
              component="p"
              sx={{
                color: "text.secondary",
                mb: 4,
                lineHeight: 1.6,
                fontWeight: 400,
              }}
            >
              Ferramenta que monitora e analisa a acessibilidade de sites,
              promovendo inclusão e melhorias na experiência digital.
            </Typography>

            {/* Avisos de erro serão exibidos via Snackbar no LoginForm para consistência */}

            {/* Lista de features */}
            {!isMobile && <FeatureList />}
          </Box>
        </Grid>

        {/* Lado direito - Formulário de login */}
        <Grid
          item
          xs={12}
          md={5}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            p: { xs: 2, md: 3 },
            order: { xs: 1, md: 2 },
          }}
        >
          <LoginForm />
        </Grid>
      </Grid>
    </Box>
  );
}
